import React from "react";

// modals
import Adduser from "./AddUser";
import CreateTask from "./CreateTask";
import TaskDetailsDialog from "./TaskDetailsDialog";

const SelectModal = ({ modalKey, modalData, modalProps, handleClose }) => {
  const action = modalProps ? modalProps.action : "";
  switch (modalKey) {
    case "add-user":
      return (
        <Adduser
          handleClose={handleClose}
          modalData={modalData}
          action={action}
          modalProps={modalProps}
        />
      );

    case "create-task":
      return (
        <CreateTask
          handleClose={handleClose}
          modalData={modalData}
          action={action}
          modalProps={modalProps}
        />
      );
    case "view-task":
      return (
        <TaskDetailsDialog
          open={true}
          handleClose={handleClose}
          modalData={modalData}
          action={action}
          modalProps={modalProps}
        />
      );

    default:
      return null;
  }
};

export default SelectModal;
